import { render, staticRenderFns } from "./InspectionWorkOrder.vue?vue&type=template&id=66f76311&scoped=true"
import script from "./InspectionWorkOrder.vue?vue&type=script&lang=js"
export * from "./InspectionWorkOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f76311",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66f76311')) {
      api.createRecord('66f76311', component.options)
    } else {
      api.reload('66f76311', component.options)
    }
    module.hot.accept("./InspectionWorkOrder.vue?vue&type=template&id=66f76311&scoped=true", function () {
      api.rerender('66f76311', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Operation/InspectionWorkOrder/InspectionWorkOrder.vue"
export default component.exports